<!----------------------- Компонент списку компаній для входу --------------------->
<template>
  <div class="choiceCompanyBox" v-if="data">
    <div class="company-container">
      <button @click="$emit('logout')" type="button" class="btn btn-sm btn-link logout-button">
        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3"
          style="float: right; fill: red;">
          <path
            d="M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h280v80H200v560h280v80H200Zm440-160-55-58 102-102H360v-80h327L585-622l55-58 200 200-200 200Z">
          </path>
        </svg>
      </button>

      <div class="user-info">
        <div class="usr-icon-login-container">
          <div class="user-icon-div">
            <div class="circle-avatar">
              <div data-v-01c4cbed="">
                <div data-v-3b0aa6a6=""><svg data-v-3b0aa6a6="" xmlns="http://www.w3.org/2000/svg" height=""
                    viewBox="0 0 24 24" fill="none" stroke="#00c279" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-user"
                    style="width: 67px;height: 67px;">
                    <path data-v-3b0aa6a6="" stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                    <path data-v-3b0aa6a6="" d="M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0"></path>
                    <path data-v-3b0aa6a6="" d="M6 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2"></path>
                  </svg></div>
              </div>
            </div>
          </div>

          <span class="person-login">{{ userLogin }}</span>
        </div>
        <span class="divider-line"></span>
      </div>

      <div class="company-scrollbox">
        <div v-for="(item, index) in data.companies" :key="index" class="companyItem"
          @click="$emit('goToCompany', item)" :class="{ 'blocked': item.blocked }">
          <img v-if="item.logo.length > 1" class="logoImg" :src="logoUrl + item.company_id + '/' + item.logo"
            alt="logo">
          <img v-else :src="defaultLogo" class="logoImg" alt="default logo">
          <div>
            <div class="company-name">{{ item.company_name }}</div>
            <div class="createDateCompany">{{ lang.creationDate }}: {{ item.date_of_create }}</div>
          </div>
        </div>
      </div>

      <span class="divider-line"></span>

      <div class="footer-buttons">
        <a href="//cabinet.skyservice.online/">
          <button type="button" class="btn btn-sm btn-link cabinet-button">
            {{ lang.goToCabinet }}
          </button>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import defaultLogo from "@/assets/default-logo.png"; // Імпортуємо зображення за замовчуванням для логотипу
export default {
  data() {
    return {
      logoUrl: 'https://img-1.skyservice.pro/uploads/images/',
      defaultLogo,
    }
  },
  props: ['data'],
  computed: {
    userLogin() {
      // Встановлення імені користувача (якщо є, інакше використовується значення за замовчуванням)
      try {
        if (this.data.user.name) {
          return this.data.user.name;
        } else {
          return this.data.user.phone;
        }
      } catch (error) {
        return this.lang['withoutName'];
      }
    },
    lang() {
      return window.lang;
    }
  },
}
</script>

<style scoped>
.choiceCompanyBox {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f8f8f8;
  ;
}

.company-container {
  background-color: #ffffff;
  /* padding: 10px; */
  width: 100%;
  max-width: 500px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  position: relative;
}

.user-info {
  text-align: center;
  font-size: 1rem;
  font-weight: 600;
  color: #212121;
  margin-bottom: 1rem;
}

.usr-icon-login-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 0.5rem;
}

.user-icon-div {
  /* width: 112px;
  height: 112px; */
  /* border-radius: 50%; */
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 0.75rem;
}

.circle-avatar {
  width: 130px;
  height: 130px;
  border-radius: 50%;
  background-color: #ffffff;
  /* або прозорий фон */
  display: flex;
  align-items: center;
  justify-content: center;
  border: 5px solid #00c279;
}

.person-login {
  font-size: 1.2rem;
  font-weight: 500;
  color: #696969;
  font-family: system-ui;
}

.company-scrollbox {
  flex: 1;
  overflow: auto;
  margin-bottom: 1.5rem;
  width: 100%;
  padding-right: 10px;
  padding-left: 10px;
}

.companyItem {
  display: flex;
  align-items: center;
  gap: 10px;
  background-color: #fff;
  border-radius: .5rem;
  margin-top: 12px;
  width: 100%;
  margin-bottom: 20px;
  padding: 25px 15px;
  /* box-shadow: 0 4px 20px rgba(0, 0, 0, .2); */
  box-shadow:
    0 -4px 10px rgba(0, 0, 0, 0.06),
    0 2px 4px rgba(0, 0, 0, 0.04),
    0 6px 10px rgba(0, 0, 0, 0.03),
    0 12px 20px rgba(0, 0, 0, 0.03);
  transition: box-shadow 0.3s ease;
  transition: all 0.3s ease-in-out;
}

@media (pointer: fine) {
  .companyItem:hover {
    /* box-shadow: 0 4px 20px rgba(0, 0, 0, .2); */
    box-shadow:
      0 -3px 8px rgba(0, 0, 0, 0.07),
      0 3px 8px rgba(0, 0, 0, 0.06),
      0 8px 15px rgba(0, 0, 0, 0.06),
      0 14px 21px rgba(0, 0, 0, 0.03);
    transition: all 0.3s ease-in-out;
    cursor: pointer;
  }
}

.logoImg {
  width: 12%;
}

@media screen and (max-width: 700px) {
  .logoImg {
    width: 15%;
  }

  .companyItem {
    padding: 16px 10px;
  }

  .company-scrollbox {
    overflow: auto;
  }
}

.company-name {
  font-size: 1rem;
  font-weight: 600;
  color: #212121;
}

.createDateCompany {
  font-size: 0.85rem;
  color: #bdbdbd;
  margin-top: 4px;
}

.footer-buttons {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.cabinet-button {
  color: #007bff;
  padding: 4px 0;
}

.logout-button {
  padding: 0;
}

.logout-button,
.cabinet-button {
  background: none;
  border: none;
  font-size: 0.85rem;
  font-weight: 500;
  cursor: pointer;
  text-transform: uppercase;
  position: relative;
  transition: color 0.2s;
}

/* .cabinet-button::after {
  background-color: #007bff;
}

.cabinet-button::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  width: 0;
  height: 1px;
  transition: width 0.2s ease;
} */

.cabinet-button:hover {
  text-decoration: underline;
}

/* .btn-link:hover {
  text-decoration: none !important;
} */

.divider-line {
  display: block;
  height: 1px;
  background-color: #ddd;
  margin: 1rem 0;
  width: 100%;
}

.blocked {
  background-color: #f8d5d6;
}
</style>
